import { useState } from "react";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { ApiFactory } from "../../core/config/ApiFactory";
import { IProgramaFidelidade } from "../interfaces/IProgramaFidelidade";

export const useProgramasFidelidade = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiEstabelecimento = ApiFactory.getApi("MS_ESTABELECIMENTOS");

    const criar = async (programa: IProgramaFidelidade) => {
        setLoading(true);
        try {
            // Preparar payload baseado no tipo
            const payload: any = {
                tipo: programa.tipo
            };

            if (programa.tipo === "CASHBACK") {
                payload.porcentagemRetorno = programa.porcentagemRetorno;
                payload.diasVencimentoCashback = programa.diasVencimentoCashback ?? null;
                payload.limiteAcumuloCashback = programa.limiteAcumuloCashback ?? null;
            } else if (programa.tipo === "ITENS") {
                payload.produtoUuids = programa.produtoUuids;
                payload.quantidadePedidosNecessarios = programa.quantidadePedidosNecessarios;
            }

            const { data } = await apiEstabelecimento.post('/programas-fidelidade', payload);
            snackbar("Programa de fidelidade cadastrado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao cadastrar o programa de fidelidade", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const atualizar = async (uuid: string, programa: IProgramaFidelidade) => {
        setLoading(true);
        try {
            // Preparar payload baseado no tipo
            const payload: any = {
                tipo: programa.tipo
            };

            if (programa.tipo === "CASHBACK") {
                payload.porcentagemRetorno = programa.porcentagemRetorno;
                payload.diasVencimentoCashback = programa.diasVencimentoCashback ?? null;
                payload.limiteAcumuloCashback = programa.limiteAcumuloCashback ?? null;
            } else if (programa.tipo === "ITENS") {
                payload.produtoUuids = programa.produtoUuids;
                payload.quantidadePedidosNecessarios = programa.quantidadePedidosNecessarios;
            }

            const { data } = await apiEstabelecimento.put(`/programas-fidelidade/${uuid}`, payload);
            snackbar("Programa de fidelidade atualizado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao atualizar o programa de fidelidade", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const buscar = async (uuid: string) => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimento.get(`/programas-fidelidade/${uuid}`);
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao buscar o programa de fidelidade", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const ativar = async (uuid: string) => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimento.put(`/programas-fidelidade/${uuid}/ativar`);
            snackbar("Programa de fidelidade ativado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao ativar o programa de fidelidade", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const inativar = async (uuid: string) => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimento.put(`/programas-fidelidade/${uuid}/inativar`);
            snackbar("Programa de fidelidade inativado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao inativar o programa de fidelidade", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    return { criar, atualizar, buscar, ativar, inativar, loading }
}

